<template>
    <div class="tree-debug-wrap">
        <!--buttons FS log-->
        <div class="btn-fs-log" v-if="fsLog" @click="openFSDialog"></div>
        <VueTree
            ref="TreeDebug"
            :style="{height: getHeightTree(), width: getWidthTree()}"
            :dataset="debugTreeData"
            :config="treeConfig"
            :collapseEnabled="false"
            :key="keyTree"
        >
            <template v-slot:node="{ node }">
                <template v-if="node.node">
                    <!--Debug node: init, end call-->
                    <div
                        v-if="node.node.type === 'DEBUG'"
                        class="debug-node"
                        :class="node.index === debugNodeActivated.index ? 'active' : ''"
                        @click="activeNode(node)"
                    >
                        <div class="centerY">
                            {{ $f.tc(node.node.name) }}

                        </div>
                        <!--Status node-->
                        <div class="status-bar centerY">
                            <div class="mr-6 latency-chip">
                                {{ node.latency }}ms
                            </div>
                            <img
                                v-if="checkNopeIsSuccess(node)"
                                src="/img/debug/success.png"
                                alt="icon-success"
                            >
                            <img
                                v-else
                                src="/img/debug/fail.png"
                                alt="icon-fail"
                            >
                        </div>
                        <!--Arrow marker-->
                        <div class="arrow-marker" v-if="node.node.name === 'end'">
                            <img src="/img/debug/marker.svg" alt="icon-arrow-marker">
                        </div>
                    </div>

                    <!--Normal node-->
                    <div
                        v-else
                        class="tree-node"
                        :class="node.index === debugNodeActivated.index ? 'active' : ''"
                        @click="activeNode(node)"
                    >
                        <div
                            class="centerY header-node"
                            :style="checkNodeHasContent(node) ? {borderBottom: '1px solid #C6C8D0'} : ''"
                        >
                            <img
                                v-if="node.index === debugNodeActivated.index"
                                :src="NodeIconActiveMap[node.node.type]"
                                alt="icon-node">
                            <img
                                v-else
                                :src="NodeIconMap[node.node.type]"
                                alt="icon-node">
                            <span class="node-name">{{ $utils.limitStringLength(node.node.name, 30) }}</span>
                        </div>
                        <div class="node-content" v-if="checkNodeHasContent(node)">
                            <!--Content for PROCESS NODE-->
                            <div
                                v-if="node.node.nlp_config
                                    && !node.node.nlp_config.dontUseNlp
                                    && scenarioSetting.version > 1"
                                class="centerY mb-6"
                                :title="node.node.nlp_config.label"
                            >
                                <img src="/img/debug/nlp.svg" alt="icon-nlp" class="icon-nlp mr-6">
                                <div class="sub-title-node">{{ node.node.nlp_config.label }}</div>
                            </div>
                            <div
                                v-if="node.output && node.output.re_prompt_name"
                                class="centerY"
                                :title="node.output.re_prompt_name"
                            >
                                <img
                                    src="/img/debug/re-prompt-name.svg"
                                    alt="icon-re-prompt-name"
                                    class="icon-re-prompt-name mr-6 sub-title-node"
                                >
                                <div class="sub-title-node">{{ node.output.re_prompt_name }}</div>
                            </div>
                            <div
                                v-if="node.output && node.output.$prompt_tag && !node.output.re_prompt_name"
                                class="centerY"
                                :title="node.output.$prompt_tag"
                            >
                                <img src="/img/debug/prompt-tag.svg" alt="icon-prompt-tag" class="icon-prompt-tag mr-6">
                                <div class="sub-title-node">{{ node.output.$prompt_tag }}</div>
                            </div>

                            <!--Content for DECISION NODE-->
                            <div
                                v-if="node.nlpResponse && node.nlpResponse.data"
                                class="centerY"
                                :title="getLabelIntent(node)"
                            >
                                <img src="/img/debug/intent.svg" alt="icon-intent" class="icon-intent mr-6">
                                <div
                                    class="sub-title-node"
                                    :style="node.nlpResponse.data.intents ? '' : {color: '#9A9A9A', fontStyle: 'italic'}"
                                >
                                    {{ getLabelIntent(node) }}
                                </div>
                            </div>
                        </div>

                        <!--Status node-->
                        <div class="status-bar centerY" v-if="node.node.type !== NodeType.RE_PROMPT">
                            <div class="mr-6 latency-chip" v-if="node.node.type === NodeType.PROCESS && node.latency">
                                {{ node.latency }}ms
                            </div>
                            <img
                                v-if="checkNopeIsSuccess(node)"
                                src="/img/debug/success.png"
                                alt="icon-success"
                            >
                            <img
                                v-else
                                src="/img/debug/fail.png"
                                alt="icon-fail"
                            >
                        </div>

                        <!--Arrow marker-->
                        <div class="arrow-marker">
                            <img src="/img/debug/marker.svg" alt="icon-arrow-marker">
                        </div>
                    </div>
                </template>
            </template>
        </VueTree>

        <!--Group buttons zoom-->
        <div class="group-btn-tree">
            <div class="btn-zoom-reset" @click="zoomReset">
            </div>
            <div class="group-zoom">
                <div class="btn-zoom-in" @click="zoomIn"></div>
                <div class="btn-zoom-out" @click="zoomOut"></div>
            </div>
        </div>
        <FSDialog ref="FSDialog"></FSDialog>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import ScenarioService from '@/services/scenario.service'
import VueTree from '@ssthouse/vue-tree-chart'
import FSDialog from '@/views/Debug/FSDialog'

const {NodeType, NodeIconMap, NodeIconActiveMap} = ScenarioService

export default {
    name: 'DebugFlow',
    components: {FSDialog, VueTree},
    data() {
        return {
            NodeType,
            NodeIconMap,
            NodeIconActiveMap,
            treeConfig: {nodeWidth: 120, nodeHeight: 120, levelHeight: 140},
            keyTree: 0
        }
    },
    computed: {
        ...mapState({
            navigation: state => state.navigation,
            scenarioSetting: state => state.scenario.scenario_setting,
            debugTreeData: state => state.debug.treeData,
            nodesSuccess: state => state.debug.nodesSuccess,
            debugNodeActivated: state => state.debug.debugNodeActivated,
            fsLog: state => state.debug.FSLog,
        }),
    },
    mounted() {
        window.addEventListener('resize', this.onResizePage)
    },
    destroyed() {
        window.removeEventListener('mouseup', this.onResizePage)
    },
    methods: {
        onResizePage() {
            this.keyTree += 1
        },
        getWidthTree() {
            let widthSvg = window.innerWidth - 900
            if (this.navigation) {
                widthSvg -= 300
            }
            return `${widthSvg}px`
        },
        getHeightTree() {
            return `${window.innerHeight - 141}px`
        },

        // functions handle tree flow
        activeNode(node) {
            this.$store.commit(this.$actionTypes.debug.DEBUG_NODE_ACTIVATED, node)
        },
        zoomReset() {
            this.$refs.TreeDebug.restoreScale()
        },
        zoomIn() {
            this.$refs.TreeDebug.zoomIn()
        },
        zoomOut() {
            this.$refs.TreeDebug.zoomOut()
        },

        // other functions
        checkNopeIsSuccess(node) {
            if (!node) return false

            let checkNodeSuccess = this.nodesSuccess.find(i => (i.index === node.index)
                && (i.node.slug === node.node.slug)
                && (i.node.id === node.node.id)
            )
            return !!checkNodeSuccess
        },
        checkNodeHasContent(node) {
            if (!node) return false

            let checkUseNlp = node.node.nlp_config && !node.node.nlp_config.dontUseNlp
            let checkExistRePrompt = node.output && node.output.re_prompt_name
            let checkExistPrompt = node.output && node.output.$prompt_tag && !node.output.re_prompt_name
            let checkNlpResponse = node.nlpResponse && node.nlpResponse.data
            return !(!checkUseNlp && !checkExistRePrompt && !checkExistPrompt && !checkNlpResponse)
        },
        openFSDialog() {
            this.$refs.FSDialog.open()
        },
        getLabelIntent(node) {
            if (!node.nlpResponse || !node.nlpResponse?.data) {
                return this.$t('empty')
            }

            return node.nlpResponse.data.intents ? (node.nlpResponse.data.intents[0]?.label || this.$t('empty')) : this.$t('empty')
        }
    },
}
</script>

<style scoped lang="scss">
.tree-debug-wrap {
    flex: 1;
    position: relative;
    height: calc(100vh - 125px);
    display: flex;
    flex-direction: column;
    align-items: center;

    .tree-node, .debug-node {
        //width: 100%;
        font-family: "open sans semi", serif;
        font-size: 14px;
        color: #545253;
        background: #fff;
        border-radius: 4px;
        border: 2px solid #C6C8D0;
        position: relative;
        user-select: none;
    }

    .debug-node {
        padding: 8px 12px;
        border-radius: 20px;
        background: #F5F5F5;
        color: #8C8C8C;
        display: flex;

    }

    .group-btn-tree {
        position: absolute;
        right: 20px;
        bottom: 60px;
        z-index: 2;
    }

    .btn-fs-log {
        position: absolute;
        right: 20px;
        top: 20px;
        z-index: 2;
        height: 34px;
        width: 34px;
        background: #FFFFFF url("/img/debug/logs.svg") no-repeat center/70%;
        cursor: pointer;
        border-radius: 5px;
        border: 1px solid #EFEFEF;
        box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;

        &:hover {
            transition: 0.3s;
            border-color: #0052CC;
            background: #0052CC url("/img/debug/logs-white.svg") no-repeat center/70%;
        }
    }

    .latency-chip {
        text-align: center;
        min-width: 36px;
        background: #0052CC;
        color: #FFFFFF;
        font-size: 11px;
        font-family: "open sans", serif;
        padding: 1px 8px;
        border-radius: 100px;
        border: 1px solid #FFFFFF;
    }
}

.tree-node {
    .header-node {
        padding: 8px 12px;

        img {
            height: 17px;
            margin-right: 6px;
        }

        .node-name {
            width: 220px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }

    .node-content {
        font-family: "open sans", serif;
        font-size: 12px;
        padding: 8px 12px;

        .icon-nlp, .icon-intent {
            width: 17px;
        }

        .icon-prompt-tag, .icon-re-prompt-name {
            width: 16px;
        }

        .sub-title-node {
            display: block;
            max-width: 220px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .status-bar {
        position: absolute;
        bottom: -12px;
        right: 10px;

        img {
            height: 20px;
        }
    }

    &.active {
        border-color: #0052CC !important;

        .header-node {
            background: #0052CC !important;
            color: #FFFFFF !important;
        }
    }
}

.debug-node, .tree-node {
    .arrow-marker {
        position: absolute;
        top: -17px;
        left: 50%;
        transform: translate(-50%, 0);
    }
}

.debug-node {
    img {
        height: 20px;
    }

    .status-bar {
        margin-left: 40px;
    }

    .latency-chip {
        padding-top: 1px;
    }

    .arrow-marker {
        top: -15px;
    }

    &.active {
        background: #EAEEFF;
        color: #0052CC;
        border-color: #0052CC !important;
    }
}

.group-btn-tree {
    .btn-zoom-reset {
        height: 34px;
        width: 34px;
        background-position: center;
        background-size: 20px;
        background-color: #FFFFFF;
        background-image: url("/img/debug/center.svg");
        cursor: pointer;
        border-radius: 5px;
        border: 1px solid #EFEFEF;
        box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;

        &:hover {
            transition: 0.3s;
            border-color: #0052CC;
            background-color: #0052CC;
            background-image: url("/img/debug/center_white.svg");
        }
    }

    .group-zoom {
        background: #FFFFFF;
        margin-top: 6px;
        border-radius: 5px;
        overflow: hidden;
        width: 34px;
        border: 1px solid #EFEFEF;
        box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;

        div {
            height: 34px;
            width: 100%;
            background-position: center;
            background-size: 13px;
            cursor: pointer;

            &:hover {
                transition: 0.3s;
                border-color: #0052CC;
                background-color: #0052CC;
            }
        }

        .btn-zoom-in {
            background-image: url("/img/debug/zoom_in.svg");
            border-bottom: 1px solid #EFEFEF;

            &:hover {
                background-image: url("/img/debug/zoom_in_white.svg");
            }
        }

        .btn-zoom-out {
            background-image: url("/img/debug/zoom_out.svg");

            &:hover {
                background-image: url("/img/debug/zoom_out_white.svg");
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    input::placeholder {
        font-family: "open sans", serif;
        font-size: 14px !important;
    }

    .node-slot {
        width: 250px !important;
    }

    .tree-container {
        z-index: 1;
    }
}
</style>
